import React from "react";
import './BenefitsSection.css';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * BenefitsSection - Sección para mostrar beneficios organizados en columnas
 * "Lo que ganás" - Check icons consistentes, mucho aire
 */
const BenefitsSection = ({ title, subtitle, columns = [], theme = 'dark', backgroundDecoration }) => {
  const scribbles = ['/Images/06.png', '/Images/07.png', '/Images/08.png'];

  return (
    <div className={`benefitsContainer benefitsContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      {title && <h2 className="benefitsTitle">{title.toUpperCase()}</h2>}
      {subtitle && <p className="benefitsSubtitle">{subtitle}</p>}

      <div className="benefitsColumns">
        {columns.map((column, columnIndex) => (
          <div
            className="benefitColumn"
            key={columnIndex}
            style={{ '--benefit-scribble': `url('${scribbles[columnIndex % scribbles.length]}')` }}
          >
            <h3 className="benefitColumnTitle">{column.title.toUpperCase()}</h3>
            <div className="benefitSeparator"></div>
            <ul className="benefitsList">
              {column.items.map((item, itemIndex) => (
                <li className="benefitItem" key={itemIndex}>
                  <span className="benefitCheck">✓</span>
                  <span className="benefitText">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsSection;
